export default __webpack_public_path__ + "static/media/faire.30306217.svg";